/*
 * Copyright (c) ITSS Software (RLO). All rights reserved.
 * Company: ITSS Software (https://itss-software.com)
 * Proprietary and confidential. Product license: https://reservepro.app/license
 */

import './css/output.global.css'; // Tailwind CSS with rp- prefix (needed for widgets compatibility)
import i18n from '@shared/service/i18n';
import router from './router';
import { createApp } from 'vue'
import App from './App.vue'
import NotifyPlugin from './plugins/notify.js';


const app = createApp(App);

app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue Error]', err, '\nComponent:', instance?.$options?.name ?? 'unknown', '\nInfo:', info);
};

app.use(i18n); 
app.use(router);
app.use(NotifyPlugin);
app.mount('#app');

 